export const GRAPHCMS_WEB_API_URL =
  'https://api-us-east-1.graphcms.com/v2/ckrbzk1w304iy01z0eskt6vas/master';
